export class EventEmitterBo {
  isCreate: boolean = false;
  claimId: string;
  activeTab: string;
  currentpageno: number;
  pageitem: number;
  employeeId: string
  clientId: string;
  companyId: string;
  payerId: string;
  resubmissionTypeLid: string;
  claimType: string;
  claimpaymentstatus: string;
  filterStartDate: string;
  filterEndDate: string;
  serviceId: string;
  interchangeControlNumber: string;
  patientControlNumber: string;
  payerClaimReferenceNumber: string;
  claimGridType: string;
  claimNote: string;
}

export class BatchFileIdList {
  claimMaterId: (number | null)[];

}
export class claimListBO {
  fromDate: string | null;
  toDate: string | null;
  claimStatusLid: string;
  resubmissionTypeLid: string | null;
  companyId: string | null;
  payerId: string | null;
  clientId: string | null;
  employeeId: string | null;
  serviceId: string | null;
  claimType: string | null;
  claimpaymentstatus: string | null;
  // isCSG: boolean = false;
  // csg: string;
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "clientName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "clientName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  patientControlNumber: string | null;
  interchangeControlNumber: string | null;
  payerClaimReferenceNumber: string | null;
  claimDate: string | null;
  is837I: boolean = false;
  claimCategory: string;
  claimStatus: string;
  claimNote: string;
  svcdateFilterType: boolean = true;
}







export class SaveBatchFileBO {
  claimId: any = [];
  clearingHouseId: string;
}


export class functionpermission {
  readytobillcreate: boolean = true;
  readytobillupdate: boolean = true;
  readytobilldelete: boolean = true;
  readytobillmultipledelete: boolean = true;
  activeclaimscreate: boolean = true;
  activeclaimsupdate: boolean = true;
  activeclaimsdelete: boolean = true;
  activeclaimsmultipledelete: boolean = true;
  activeclaimsmovetoachieve: boolean = true

  achieveclaimscreate: boolean = true;
  achieveclaimsupdate: boolean = true;
  achieveclaimsdelete: boolean = true;
  achieveclaimsmultipledelete: boolean = true;
  achieveclaimsmovetoactive: boolean = true

}

export class IdDatesBO {
  id: string;
  date: null;
}

export class claiminput {
  from: string = '';
  ids: string[] = [];
  start: string = '';
  end: string = '';
  claimId: string;
  claimType: string;
  //errorValidation:boolean=false;
}




